export default __webpack_public_path__ + "static/media/Nosotros_imagen1_1440.062a358f.jpg";